// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authentication-footer .footer-logo img {
  max-height: 30px;
}

.authentication-footer .footer-small-print {
  font-size: 12px;
}

.authentication-footer .footer-small-print span {
  margin-left: 10px;
}

.authentication-footer,
.authentication-footer a {
  color: var(--ce-grey-30);
}

.authentication-footer .footer-disclaimer {
  text-align: right;
}

@media (max-width: 767px) {
  .authentication-footer,
  .authentication-footer.download-wrapper-show .footer-content {
    justify-content: center;
  }
}

.footer-main-wrapper {
  padding: var(--ce-base-padding-large);
}

/* DOWNLOAD APP */

.authentication-footer.download-wrapper-show {
  padding: var(--ce-base-padding-large) 0 70px 0;
}

.authentication-footer.download-wrapper-show .footer-content {
  padding: 0 var(--ce-base-padding-large);
  flex-wrap: wrap;
  gap: 10px;
}

.download-wrapper {
  display: flex;
  padding: 0.25em;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: var(--ce-white);
  z-index: 5;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--ce-grey-10-base);
}
@media (max-height: 500px) {
  .download-wrapper {
    position: static;
  }
  .authentication-footer.download-wrapper-show {
    padding-bottom: 0;
  }
}
.download-wrapper.hide {
  display: none;
}
.download-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.download-icon {
  height: 44px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/LoginFooter.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;;AAEjB;EACE,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;AACd","sourcesContent":[".authentication-footer .footer-logo img {\n  max-height: 30px;\n}\n\n.authentication-footer .footer-small-print {\n  font-size: 12px;\n}\n\n.authentication-footer .footer-small-print span {\n  margin-left: 10px;\n}\n\n.authentication-footer,\n.authentication-footer a {\n  color: var(--ce-grey-30);\n}\n\n.authentication-footer .footer-disclaimer {\n  text-align: right;\n}\n\n@media (max-width: 767px) {\n  .authentication-footer,\n  .authentication-footer.download-wrapper-show .footer-content {\n    justify-content: center;\n  }\n}\n\n.footer-main-wrapper {\n  padding: var(--ce-base-padding-large);\n}\n\n/* DOWNLOAD APP */\n\n.authentication-footer.download-wrapper-show {\n  padding: var(--ce-base-padding-large) 0 70px 0;\n}\n\n.authentication-footer.download-wrapper-show .footer-content {\n  padding: 0 var(--ce-base-padding-large);\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.download-wrapper {\n  display: flex;\n  padding: 0.25em;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  background: var(--ce-white);\n  z-index: 5;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid var(--ce-grey-10-base);\n}\n@media (max-height: 500px) {\n  .download-wrapper {\n    position: static;\n  }\n  .authentication-footer.download-wrapper-show {\n    padding-bottom: 0;\n  }\n}\n.download-wrapper.hide {\n  display: none;\n}\n.download-link {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.download-icon {\n  height: 44px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
